import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
import { insights } from '../lib/data';
import { Eyebrow, Reveal } from '../components/ui/Reveal';
export function Insights() {
  const [featured, ...rest] = insights;
  return <div className="mx-auto max-w-7xl px-6 py-12 lg:px-10 lg:py-16" data-id="element-485" data-mp="253ar4w7gxwgh">
      <div className="max-w-2xl" data-id="element-486" data-mp="2a4qckpdk64ze">
        <Eyebrow data-id="element-487" data-mp="2xtt02duvis1t">Perspectives</Eyebrow>
        <h1 className="mt-6 font-serif text-4xl leading-tight text-ink sm:text-5xl" data-id="element-488" data-mp="2xuuf0tf0fyot">
          Insights
        </h1>
        <p className="mt-4 text-lg leading-relaxed text-ink-600" data-id="element-489" data-mp="31uuqq6aq5vs6">
          Considered thinking on leadership, succession and the future of work.
        </p>
      </div>

      <Reveal data-id="element-490" data-mp="2stwuwbafwuko">
        <a href="#" className="group mt-12 grid overflow-hidden rounded-3xl border border-ink/10 bg-ivory-50 lg:grid-cols-2" data-id="element-491" data-mp="2stermupd1g39">
          <div className="overflow-hidden" data-id="element-492" data-mp="1hfj9dd35sr7t">
            <motion.img src={featured.image} alt={featured.title} className="h-64 w-full object-cover lg:h-full" whileHover={{
            scale: 1.04
          }} transition={{
            duration: 0.6,
            ease: [0.16, 1, 0.3, 1]
          }} data-id="element-493" data-mp="1hgc93u3paggg" />
          </div>
          <div className="flex flex-col justify-center p-8 lg:p-12" data-id="element-494" data-mp="1226tb6vv25qa">
            <div className="flex items-center gap-3 text-xs uppercase tracking-widest2 text-gold-dark" data-id="element-495" data-mp="x1rialz1xabh">
              <span data-id="element-496" data-mp="1b1k6oan3vega">{featured.category}</span>
              <span className="h-1 w-1 rounded-full bg-ink/20" data-id="element-497" data-mp="1b092watnu6p6" />
              <span className="text-ink-400" data-id="element-498" data-mp="16zfdfd0kkju6">{featured.date}</span>
            </div>
            <h2 className="mt-4 font-serif text-3xl leading-snug text-ink" data-id="element-499" data-mp="1ksept6521xxi">
              {featured.title}
            </h2>
            <p className="mt-4 text-base leading-relaxed text-ink-600" data-id="element-500" data-mp="1fu3hx0yblxhx">
              {featured.excerpt}
            </p>
            <span className="mt-6 inline-flex items-center gap-2 text-sm font-medium text-ink transition-colors group-hover:text-gold-dark" data-id="element-501" data-mp="1uqaylraisgsg">
              Read the article <ArrowRightIcon className="h-4 w-4" data-id="element-502" data-mp="1wuxx0l6nbvb3" />
            </span>
          </div>
        </a>
      </Reveal>

      <div className="mt-10 grid gap-8 md:grid-cols-2 lg:grid-cols-3" data-id="element-503" data-mp="21uastvfhwcpt">
        {rest.map((insight, i) => <Reveal key={insight.id} delay={i * 0.1} data-id="element-504" data-mp="26rkh37r5eic2" data-mpi={i}>
            <a href="#" className="group block" data-id="element-505" data-mp="2bispc0gqrxnn">
              <div className="overflow-hidden rounded-2xl" data-id="element-506" data-mp="2bknc7kbkpzud">
                <motion.img src={insight.image} alt={insight.title} className="h-56 w-full object-cover" whileHover={{
              scale: 1.05
            }} transition={{
              duration: 0.6,
              ease: [0.16, 1, 0.3, 1]
            }} data-id="element-507" data-mp="2giova5901z5u" />
              </div>
              <div className="mt-5" data-id="element-508" data-mp="2ugvjeto5cksb">
                <div className="flex items-center gap-3 text-xs uppercase tracking-widest2 text-gold-dark" data-id="element-509" data-mp="2ufu7yo37xwa2">
                  <span data-id="element-510" data-mp="v75j1zx0o6ta">{insight.category}</span>
                  <span className="h-1 w-1 rounded-full bg-ink/20" data-id="element-511" data-mp="104ynooio8srg" />
                  <span className="text-ink-400" data-id="element-512" data-mp="sk4jr5nupb4j">{insight.readTime}</span>
                </div>
                <h3 className="mt-3 font-serif text-xl leading-snug text-ink transition-colors group-hover:text-gold-dark" data-id="element-513" data-mp="nto7hovrnvjr">
                  {insight.title}
                </h3>
                <p className="mt-2 text-sm leading-relaxed text-ink-600" data-id="element-514" data-mp="ish03qxjcydm">
                  {insight.excerpt}
                </p>
              </div>
            </a>
          </Reveal>)}
      </div>
    </div>;
}